import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandheroWorkingOnComputerDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 380,
	height: 250,
	viewBox: "0 0 380 250",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6479_17438)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M371.382 210.585H375.062C377.085 210.585 378.723 212.223 378.723 214.246V219.826C378.723 226.188 373.562 231.35 367.201 231.35H365.331V216.637C365.331 213.29 368.043 210.585 371.382 210.585ZM371.382 212.978C369.365 212.978 367.723 214.62 367.723 216.637V228.956L368.246 228.896C372.784 228.369 376.322 224.507 376.322 219.826V214.246C376.322 213.546 375.754 212.978 375.054 212.978H371.382Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .938838
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M332.627 248.385C331.219 248.385 330.07 247.236 330.07 245.828V241.456H355.052V245.828C355.052 247.236 353.903 248.385 352.495 248.385H332.635H332.627Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M354.22 242.289V245.828C354.22 246.778 353.445 247.552 352.496 247.552H332.636C331.686 247.552 330.912 246.778 330.912 245.828V242.289H354.228M355.885 240.623H329.238V245.828C329.238 247.702 330.754 249.218 332.627 249.218H352.488C354.361 249.218 355.877 247.702 355.877 245.828V240.623H355.885Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M330.818 243.57C323.74 243.57 317.986 237.815 317.986 230.736V207.175C317.986 205.401 319.427 203.96 321.201 203.96H363.919C365.692 203.96 367.133 205.401 367.133 207.175V230.736C367.133 237.815 361.379 243.57 354.301 243.57H330.818Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M363.919 204.801C365.235 204.801 366.301 205.867 366.301 207.183V230.744C366.301 237.365 360.922 242.745 354.302 242.745H330.819C324.199 242.745 318.82 237.365 318.82 230.744V207.183C318.82 205.867 319.886 204.801 321.201 204.801H363.919ZM363.919 203.136H321.201C318.97 203.136 317.154 204.943 317.154 207.183V230.744C317.154 238.29 323.275 244.411 330.819 244.411H354.302C361.846 244.411 367.966 238.29 367.966 230.744V207.183C367.966 204.951 366.159 203.136 363.919 203.136Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M335.408 243.378C350.047 242.636 348.865 229.186 348.865 229.186V203.901H363.038C365.211 203.901 366.976 205.667 366.976 207.841V229.811C366.976 237.306 360.906 243.378 353.411 243.378H335.408Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M336.496 176.955C335.819 179.173 335.761 181.509 337.004 183.658V183.659C337.482 184.602 338.242 185.367 338.991 186.056C339.762 186.764 340.506 187.381 341.082 188.084L341.094 188.099L341.107 188.112C342.542 189.598 343.396 191.725 343.429 193.795C343.447 194.934 343.214 196.044 342.703 197.018C343.04 196.046 343.175 194.997 343.121 194.033L343.104 193.791L343.103 193.784L343.072 193.535C342.723 190.986 341.112 188.814 339.167 187.185C338.527 186.589 337.764 185.89 337.229 185.188L337.016 184.888L336.998 184.862L336.979 184.839L336.847 184.665C336.713 184.469 336.578 184.215 336.476 183.992L336.462 183.965L336.286 183.617C335.466 181.865 335.486 179.922 336.07 178.071C336.19 177.694 336.333 177.32 336.496 176.955Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .938838
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M347.713 168.302C347.036 170.52 346.978 172.856 348.221 175.005V175.006C348.699 175.949 349.459 176.714 350.208 177.402C350.979 178.111 351.723 178.728 352.299 179.431L352.311 179.445L352.324 179.459C353.759 180.945 354.615 183.072 354.648 185.142C354.667 186.288 354.433 187.404 353.914 188.383C354.256 187.406 354.392 186.35 354.338 185.38L354.32 185.138L354.319 185.131L354.289 184.882C353.94 182.333 352.329 180.161 350.384 178.531C349.744 177.936 348.981 177.237 348.446 176.535L348.232 176.234L348.215 176.209L348.195 176.186L348.063 176.012C347.93 175.815 347.795 175.562 347.692 175.339L347.679 175.312L347.503 174.964C346.682 173.211 346.702 171.268 347.287 169.418C347.406 169.04 347.55 168.667 347.713 168.302Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .938838
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M270.672 180.757C268.407 158.287 262.487 129.238 256.416 105.102C254.684 98.2478 252.952 91.8433 251.295 86.1467C245.3 65.5424 242.543 39.4247 223.824 25.7496C203.139 10.6337 169.206 12.8657 153.227 33.9863C141.893 48.969 138.712 68.5239 133.566 86.1467C131.859 91.9932 130.086 98.5892 128.312 105.635C122.283 129.679 116.387 158.936 114.139 181.24L94.4121 188.968L109.617 246.75H194.171H189.824H274.378L289.583 188.968L270.714 181.215L270.664 180.757H270.672Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 3.75535,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M194.447 214.278C194.156 214.278 193.872 214.278 193.581 214.27C183.48 214.062 172.963 210.864 164.736 205.509C152.845 197.763 145.75 185.554 145.75 172.853C145.75 162.068 151.013 151.799 160.572 143.929C169.849 136.292 182.206 131.911 194.472 131.911C200.243 131.911 205.897 132.861 211.259 134.726C216.272 136.475 220.952 138.924 225.491 141.297C230.337 143.829 235.342 146.452 240.821 148.268C246.608 150.184 252.287 151.158 257.692 151.158C260.681 151.158 263.562 150.85 266.277 150.25C266.543 151.791 267.193 155.505 268.483 162.41C268.633 163.192 268.892 168.772 269.058 172.978C267.734 172.62 266.385 172.445 265.044 172.445C255.152 172.445 246.45 181.989 238.031 191.217C232.527 197.247 227.331 202.944 222.043 205.842C214.049 210.231 205.172 214.287 194.464 214.287L194.447 214.278Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M194.463 132.745C200.142 132.745 205.696 133.678 210.976 135.519C215.93 137.243 220.585 139.683 225.09 142.04C229.961 144.588 234.999 147.22 240.545 149.06C246.416 151.009 252.178 151.992 257.674 151.992C260.414 151.992 263.062 151.742 265.585 151.243C265.918 153.133 266.551 156.698 267.65 162.561C267.758 163.177 267.983 167.466 268.166 171.913C267.125 171.705 266.076 171.605 265.027 171.605C254.768 171.605 245.933 181.283 237.398 190.644C231.943 196.624 226.797 202.27 221.626 205.102C213.724 209.433 204.963 213.447 194.446 213.447C194.163 213.447 193.88 213.447 193.597 213.439C183.646 213.23 173.287 210.091 165.185 204.81C153.535 197.223 146.582 185.272 146.582 172.846C146.582 162.319 151.736 152.275 161.104 144.563C170.231 137.051 182.397 132.737 194.471 132.737M194.463 131.08C168.732 131.08 144.908 149.702 144.908 172.846C144.908 185.838 152.153 198.314 164.269 206.201C172.513 211.573 183.155 214.888 193.555 215.096C193.855 215.096 194.146 215.104 194.438 215.104C204.863 215.104 213.774 211.298 222.417 206.559C236.057 199.08 249.23 173.263 265.019 173.263C266.617 173.263 268.25 173.529 269.915 174.104C269.915 174.104 269.515 163.469 269.282 162.244C267.475 152.567 266.926 149.227 266.926 149.227C263.911 149.985 260.797 150.318 257.666 150.318C252.028 150.318 246.333 149.219 241.061 147.47C230.511 143.972 221.926 137.567 211.517 133.936C205.888 131.979 200.125 131.071 194.455 131.071L194.463 131.08Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M193.845 117.588C188.382 117.588 183.036 116.713 177.957 114.981C173.21 113.365 168.772 111.1 164.475 108.91C159.887 106.57 155.14 104.146 149.944 102.464C144.448 100.69 139.069 99.7903 133.956 99.7903C132.84 99.7903 131.733 99.8319 130.65 99.9235L141.875 59.3895C151.293 57.8904 160.153 53.4431 167.748 49.3788C175.334 45.3229 183.744 41.5752 193.862 41.5752C194.136 41.5752 194.411 41.5752 194.694 41.5835C204.262 41.7751 214.213 44.7316 222.007 49.6787C233.249 56.8244 239.969 68.0843 239.969 79.8106C239.969 89.7546 234.989 99.2239 225.946 106.486C217.161 113.54 205.461 117.588 193.853 117.588H193.845Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M193.863 40.7422V42.4079C194.129 42.4079 194.404 42.4079 194.679 42.4162C204.097 42.6077 213.898 45.5143 221.567 50.3864C232.567 57.3739 239.137 68.3756 239.137 79.8104C239.137 89.4963 234.266 98.7407 225.431 105.836C216.796 112.774 205.288 116.755 193.854 116.755C188.475 116.755 183.221 115.897 178.224 114.198C173.536 112.607 169.123 110.35 164.851 108.177C160.229 105.82 155.458 103.38 150.204 101.681C144.624 99.8817 139.153 98.9656 133.957 98.9656C133.225 98.9656 132.492 98.9823 131.767 99.0239L142.534 60.1306C151.877 58.5315 160.629 54.1425 168.14 50.1199C175.626 46.114 183.928 42.4162 193.863 42.4162V40.7505M193.863 40.7422C183.987 40.7422 175.551 44.2651 167.357 48.6458C158.864 53.1931 150.345 57.3073 141.219 58.6481L129.527 100.873C130.993 100.706 132.475 100.631 133.957 100.631C139.295 100.631 144.691 101.647 149.696 103.263C159.688 106.494 167.824 112.416 177.691 115.772C183.021 117.588 188.483 118.421 193.854 118.421C218.236 118.421 240.803 101.206 240.803 79.8104C240.803 67.801 233.941 56.2745 222.458 48.9789C214.647 44.0152 204.571 40.9504 194.712 40.7505C194.429 40.7505 194.146 40.7422 193.863 40.7422Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M217.778 22.104C213.298 19.7221 208.543 18.1064 203.589 17.2152C198.651 16.1242 193.171 15.8827 188.517 13.5175C185.361 11.9018 182.413 9.295 181.139 5.92202L181.413 5.73047C182.804 6.80482 184.136 7.72094 185.535 8.51213C191.298 11.4354 197.868 13.3592 204.122 15.0665C209.06 16.5073 213.856 18.7726 217.97 21.8291L217.795 22.1123L217.778 22.104Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M168.848 88.0715C177.582 88.0715 184.662 80.9906 184.662 72.2559C184.662 63.5213 177.582 56.4404 168.848 56.4404C160.115 56.4404 153.035 63.5213 153.035 72.2559C153.035 80.9906 160.115 88.0715 168.848 88.0715Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M168.599 88.0633C175.35 88.0633 180.823 82.5896 180.823 75.8373C180.823 69.0851 175.35 63.6113 168.599 63.6113C161.848 63.6113 156.375 69.0851 156.375 75.8373C156.375 82.5896 161.848 88.0633 168.599 88.0633Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M179.396 70.947C180.339 70.0038 179.735 67.8708 178.047 66.1828C176.36 64.4948 174.227 63.891 173.284 64.8342C172.341 65.7774 172.944 67.9104 174.632 69.5984C176.32 71.2864 178.453 71.8902 179.396 70.947Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M216.405 88.0715C225.138 88.0715 232.218 80.9906 232.218 72.2559C232.218 63.5213 225.138 56.4404 216.405 56.4404C207.672 56.4404 200.592 63.5213 200.592 72.2559C200.592 80.9906 207.672 88.0715 216.405 88.0715Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M216.406 88.0633C223.157 88.0633 228.63 82.5896 228.63 75.8373C228.63 69.0851 223.157 63.6113 216.406 63.6113C209.655 63.6113 204.182 69.0851 204.182 75.8373C204.182 82.5896 209.655 88.0633 216.406 88.0633Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227.206 67.366C226.265 68.3071 224.125 67.7075 222.434 66.0168C220.744 64.3262 220.144 62.1941 221.085 61.2447C222.026 60.3036 224.166 64.4844 225.857 66.1751C227.547 67.8657 228.147 66.4166 227.206 67.3577V67.366Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M225.822 34.3616L212.848 37.6596C210.975 38.1343 209.076 37.3431 208.243 35.7441L206.711 32.7959C206.203 31.8131 207.127 30.6305 208.277 30.7971L225.822 33.3872C226.371 33.4705 226.371 34.22 225.822 34.3616Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M159.432 34.3616L172.405 37.6596C174.279 38.1343 176.178 37.3431 177.01 35.7441L178.542 32.7959C179.05 31.8131 178.126 30.6305 176.977 30.7971L159.432 33.3872C158.882 33.4705 158.882 34.22 159.432 34.3616Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M278.659 247.142C277.351 247.142 276.052 246.976 274.795 246.659C269.332 245.26 264.927 240.963 262.387 234.558C259.773 227.971 259.456 219.992 261.48 212.097C265.102 197.98 275.386 187.736 285.928 187.736C287.236 187.736 288.535 187.903 289.792 188.219C295.255 189.619 299.66 193.916 302.199 200.32C304.814 206.908 305.131 214.887 303.107 222.782C299.485 236.899 289.201 247.142 278.659 247.142Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M285.936 189.394C287.102 189.394 288.268 189.544 289.384 189.827C294.313 191.093 298.319 195.04 300.659 200.929C303.14 207.191 303.44 214.804 301.5 222.357C299.793 229.012 296.445 235.016 292.082 239.256C287.968 243.262 283.205 245.46 278.667 245.46C277.501 245.46 276.335 245.31 275.219 245.027C270.29 243.761 266.284 239.814 263.944 233.925C261.463 227.663 261.163 220.05 263.103 212.497C264.81 205.842 268.158 199.838 272.521 195.598C276.635 191.593 281.398 189.394 285.936 189.394ZM285.936 186.062C274.845 186.062 263.745 196.59 259.872 211.672C255.501 228.704 261.996 245.085 274.378 248.267C275.794 248.633 277.226 248.808 278.658 248.808C289.75 248.808 300.85 238.281 304.722 223.199C309.094 206.167 302.599 189.785 290.216 186.604C288.801 186.237 287.369 186.062 285.936 186.062Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M264.404 140.764C264.404 140.764 274.188 179.549 246.667 221.382C219.146 263.215 203.491 217.334 222.111 199.52C240.73 181.706 240.047 142.579 240.047 142.579",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M264.404 140.764C264.404 140.764 274.188 179.549 246.667 221.382C219.146 263.215 203.491 217.334 222.111 199.52C240.73 181.706 240.047 142.579 240.047 142.579",
				stroke: "#001321",
				strokeWidth: 3.75535,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.561 140.764C120.561 140.764 110.776 179.549 138.298 221.382C165.819 263.215 181.474 217.334 162.854 199.52C144.235 181.706 144.918 142.579 144.918 142.579",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.561 140.764C120.561 140.764 110.776 179.549 138.298 221.382C165.819 263.215 181.474 217.334 162.854 199.52C144.235 181.706 144.918 142.579 144.918 142.579",
				stroke: "#001321",
				strokeWidth: 3.75535,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M163.627 215.237C154.309 204.976 147.215 192.717 143.517 179.341C142.585 175.96 141.894 172.487 141.069 169.073C135.84 146.894 138.379 113.772 144.417 92.2437C147.814 80.126 151.62 67.8583 155.433 55.8072C160.671 39.2588 169.19 23.1768 186.161 16.5225C173.828 18.1965 162.195 23.9597 154.609 33.987C143.276 48.978 140.095 68.5329 134.949 86.1474C133.242 91.9939 131.468 98.5899 129.694 105.636C123.665 129.68 115.596 157.505 113.348 179.808C112.915 184.097 102.931 183.098 102.789 186.787C102.731 188.319 110.9 190.21 110.076 193.316C108.618 198.846 113.864 212.272 113.873 212.555C113.873 213.413 123.64 217.494 123.674 218.293C124.69 244.719 109.251 248.267 109.251 248.267L115.871 248.25L188.451 246.751H193.805C193.805 246.751 216.963 247.076 216.971 247.076C212.666 247.551 195.379 238.498 191.631 236.607C181.148 231.319 171.563 224.006 163.602 215.237H163.627Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.013 237.939H124.839C124.062 237.939 123.432 238.57 123.432 239.347V246.426C123.432 247.203 124.062 247.833 124.839 247.833H260.013C260.79 247.833 261.42 247.203 261.42 246.426V239.347C261.42 238.57 260.79 237.939 260.013 237.939Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M105.34 247.143C94.7982 247.143 84.5142 236.899 80.8919 222.783C78.8685 214.888 79.1849 206.909 81.7996 200.321C84.3394 193.917 88.7444 189.62 94.207 188.22C95.4644 187.896 96.7634 187.737 98.0708 187.737C108.613 187.737 118.897 197.981 122.519 212.098C124.543 219.993 124.226 227.972 121.612 234.559C119.072 240.964 114.667 245.261 109.204 246.66C107.947 246.985 106.648 247.143 105.34 247.143Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M98.0705 186.063V189.394C102.609 189.394 107.372 191.601 111.486 195.599C115.849 199.846 119.196 205.851 120.904 212.497C122.844 220.059 122.544 227.663 120.062 233.926C117.723 239.822 113.726 243.762 108.796 245.028C107.672 245.319 106.514 245.461 105.348 245.461C100.81 245.461 96.0471 243.254 91.9335 239.256C87.57 235.009 84.2225 229.004 82.5155 222.358C78.6101 207.134 84.0393 192.542 94.6231 189.819C95.7473 189.528 96.9047 189.386 98.0705 189.386V186.055M98.0705 186.063C96.6383 186.063 95.206 186.238 93.7904 186.604C81.408 189.786 74.9128 206.168 79.2846 223.199C83.1567 238.282 94.2567 248.809 105.348 248.809C106.781 248.809 108.213 248.634 109.629 248.267C122.011 245.086 128.506 228.704 124.134 211.673C120.262 196.59 109.162 186.063 98.0705 186.063Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M248.142 170.156H136.725V247.835H248.142V170.156Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 3.75535,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M177.176 199.538C177.176 196.956 179.266 194.857 181.839 194.857H189.608C190.158 194.857 190.682 194.949 191.165 195.124C193.514 195.957 195.67 197.972 198.152 197.972C200.633 197.972 202.798 195.957 205.138 195.124C205.63 194.949 206.154 194.857 206.695 194.857C209.269 194.857 211.359 196.956 211.359 199.538C211.359 202.12 209.269 204.218 206.695 204.218C206.146 204.218 205.621 204.127 205.138 203.952C202.79 203.119 200.633 201.104 198.152 201.104C195.67 201.104 193.505 203.119 191.165 203.952C190.674 204.127 190.149 204.218 189.608 204.218H181.839C179.266 204.218 177.176 202.12 177.176 199.538ZM177.176 212.022C177.176 209.44 179.266 207.342 181.839 207.342C182.522 207.342 183.171 207.492 183.763 207.758C185.819 208.691 187.751 210.465 190 210.465C192.248 210.465 194.188 208.691 196.237 207.758C196.819 207.492 197.469 207.342 198.16 207.342C200.733 207.342 202.823 209.44 202.823 212.022C202.823 214.604 200.733 216.703 198.16 216.703C197.477 216.703 196.828 216.553 196.237 216.286C194.18 215.353 192.248 213.58 190 213.58C187.751 213.58 185.811 215.353 183.763 216.286C183.18 216.553 182.53 216.703 181.839 216.703C179.266 216.703 177.176 214.604 177.176 212.022ZM181.839 219.826C179.266 219.826 177.176 221.925 177.176 224.506C177.176 227.088 179.266 229.187 181.839 229.187C184.412 229.187 186.502 227.088 186.502 224.506C186.502 221.925 184.412 219.826 181.839 219.826Z",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M351.905 1.54785H261.63C258.669 1.54785 256.268 3.94915 256.268 6.9113V66.8837C256.268 69.8458 258.669 72.2471 261.63 72.2471H351.905C354.866 72.2471 357.267 69.8458 357.267 66.8837V6.9113C357.267 3.94915 354.866 1.54785 351.905 1.54785Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M261.631 1.54785H351.897C354.861 1.54785 357.259 3.95474 357.259 6.9113V12.2748H256.26V6.9113C256.26 3.94641 258.666 1.54785 261.622 1.54785H261.631Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M263.66 9.22718C264.934 9.22718 265.967 8.19432 265.967 6.92023C265.967 5.64614 264.934 4.61328 263.66 4.61328C262.386 4.61328 261.354 5.64614 261.354 6.92023C261.354 8.19432 262.386 9.22718 263.66 9.22718Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M122.176 32.4492C123.19 32.4492 124.013 33.2714 124.013 34.2861C124.013 35.301 123.19 36.124 122.176 36.124C121.161 36.124 120.339 35.301 120.339 34.2861C120.339 33.2714 121.161 32.4492 122.176 32.4492Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .938838
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M342.562 152.044C343.577 152.044 344.399 152.866 344.399 153.881C344.399 154.896 343.577 155.719 342.562 155.719C341.548 155.719 340.726 154.896 340.726 153.881C340.726 152.866 341.548 152.044 342.562 152.044Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .938838
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.3164 193.021C45.3309 193.021 46.1532 193.843 46.1533 194.857C46.1533 195.872 45.331 196.695 44.3164 196.695C43.3018 196.695 42.4795 195.872 42.4795 194.857C42.4797 193.843 43.3019 193.021 44.3164 193.021Z",
				fill: "white",
				stroke: "white",
				strokeWidth: .938838
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M273.162 9.22718C274.436 9.22718 275.469 8.19432 275.469 6.92023C275.469 5.64614 274.436 4.61328 273.162 4.61328C271.888 4.61328 270.855 5.64614 270.855 6.92023C270.855 8.19432 271.888 9.22718 273.162 9.22718Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M282.266 9.22718C283.539 9.22718 284.572 8.19432 284.572 6.92023C284.572 5.64614 283.539 4.61328 282.266 4.61328C280.992 4.61328 279.959 5.64614 279.959 6.92023C279.959 8.19432 280.992 9.22718 282.266 9.22718Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M362.155 120.476C368.396 120.476 373.455 115.416 373.455 109.175C373.455 102.933 368.396 97.873 362.155 97.873C355.915 97.873 350.855 102.933 350.855 109.175C350.855 115.416 355.915 120.476 362.155 120.476Z",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.3175 115.205C50.5583 115.205 55.6174 110.145 55.6174 103.903C55.6174 97.6614 50.5583 92.6016 44.3175 92.6016C38.0767 92.6016 33.0176 97.6614 33.0176 103.903C33.0176 110.145 38.0767 115.205 44.3175 115.205Z",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.698 98.707H292.855V120.552H314.698V98.707Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M313.865 99.5397V119.719H293.689V99.5397H313.865ZM315.531 97.874H292.023V121.385H315.531V97.874Z",
				fill: "#012f6e",
				fillOpacity: .0666667
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.7639 112.391H71.9219V134.236H93.7639V112.391Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M92.9319 113.223V133.403H72.7553V113.223H92.9319ZM94.5973 111.558H71.0898V135.069H94.5973V111.558Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M320.438 109.626H347.034",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M273.164 75.8379V149.094",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M303.783 149.686H273.164",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.748 153.881H305.129",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M303.781 127.082V177.643",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256.268 177.643H303.782",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.901 177.643H82.8457",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.8457 140.764V177.642",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.1094 157.305H82.8472",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.4375 56.4404H122.175",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.3184 184.439V123.317",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.8457 106.403V40.7422",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M122.176 56.4411V40.7422",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.6004 98.6816L37.4043 103.879L42.6421 109.117",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.9816 98.6816L51.1777 103.879L45.9316 109.117",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.7948 23.0701C87.5292 23.0701 90.5565 20.0424 90.5565 16.3075C90.5565 12.5726 87.5292 9.54492 83.7948 9.54492C80.0605 9.54492 77.0332 12.5726 77.0332 16.3075C77.0332 20.0424 80.0605 23.0701 83.7948 23.0701Z",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.1066 32.2225L79.2663 26.0179L73.837 28.8495L70.5395 25.7847L74.27 20.4296L67.9414 18.8222V13.9252L74.27 11.9347L71.1557 7.48735L74.27 4.43085L79.3412 7.11257L81.1066 0.833008H85.7698L87.5351 7.11257L92.6147 4.43085L95.7207 7.48735L92.6147 11.9347L98.935 13.9252V18.8222L92.6147 20.4296L96.3369 25.7847L93.0477 28.8495L87.6101 26.0179L85.7698 32.2225H81.1066Z",
				stroke: "white",
				strokeWidth: 1.87768,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M204.305 95.1514C202.831 101.889 198.642 106.853 193.33 107.286C188.025 107.719 183.087 103.496 180.539 97.0835C183.912 99.1073 188.183 100.148 192.722 99.7819C197.26 99.4155 201.307 97.6998 204.305 95.1514Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 2.81651,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 248.251C121.867 246.011 246.241 246.069 368.126 248.001L380 248.251L368.126 248.501C246.233 250.425 121.876 250.483 0 248.251Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6479_17438",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 380,
			height: 250,
			fill: "white"
		})
	}) })]
});
export default SvgBrandheroWorkingOnComputerDark;
